import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        wishlistStack: {
            w: '100%',
            alignItems: 'center',
            gap: {base: remCalc(0), lg: remCalc(40)},
        },
        wishlistWidgetStack: {
            w: '100%',
            alignItems: 'center',
            gap: 0,
        },
        wishlistStackGuest: {
            paddingY: {base: remCalc(40), lg: remCalc(100)},
            paddingInline: {base: remCalc(16), md: remCalc(24), xl: remCalc(260)},
        },
        wishlistLogin: {
            w: '100%',
            alignItems: 'flex-start',
            gap: remCalc(18),
        },
        wishlistBackButton: {
            textStyle: 'body-medium',
        },
        wishlistTitle: {
            textStyle: 'head-xlarge',
            color: 'text.default',
            fontWeight: 'medium',
            paddingTop: remCalc(24),
            paddingBottom: remCalc(24),
        },
        wishlistWidgetTitle: {
            textStyle: 'head-medium',
            color: 'text.default',
            fontWeight: 'medium',
        },
        wishlistTextSuggestion: {
            textStyle: 'body-medium',
            color: 'text.default',
            maxWidth: 'unset',
        },
        wishlistLoginButton: {
            minWidth: remCalc(140),
        },
        wishlistLoginButtonFlex: {
            gap: remCalc(24),
        },
        wishlistLoginStack: {
            w: '100%',
            paddingBottom: {base: remCalc(28), lg: remCalc(40)},
            gap: remCalc(28),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
        },
        heading: {
            textStyle: 'head-large',
            color: 'text.default',
            textAlign: 'center',
        },
        text: {
            textStyle: 'body-small',
            color: 'text.default',
            textAlign: 'center',
        },
        textButton: {
            display: {base: 'none', lg: 'flex'},
            fontWeight: 'normal',
        },
        container: {
            gap: 'medium.base',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: remCalc(529),
        },
        sharedWishlistContainer: {
            flexDirection: 'column',
            paddingInline: {base: 'small.md', xl: remCalc(260)},
            paddingY: {base: 'medium.md', lg: remCalc(100)},
            gap: 'large.base',
        },
        sharedWishlistTitleContainer: {
            flexDirection: 'column',
            gap: remCalc(18),
            alignItems: 'flex-start',
        },
        sharedWishlistDivider: {color: 'border.light'},
        pageActioncontainer: {gap: 'medium.md'},
        shareIcon: {
            boxSize: {base: 'iconsSize.medium', md: 'iconsSize.small'},
            color: 'icons.background.secondary',
        },
        wishlistShare: {
            w: '100%',
            justifyContent: 'space-between',
            paddingY: remCalc(24),
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            alignItems: 'center',
        },
        wishlistWidget: {
            w: '100%',
            justifyContent: 'space-between',
            paddingY: remCalc(16),
            alignItems: 'center',
        },
        iconShareFlex: {
            paddingY: remCalc(18),
            gap: remCalc(12),
            alignItems: 'center',
        },
        sharedWishlistGrid: {
            display: 'grid',
            gridTemplateColumns: {base: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)'},
            alignItems: 'flex-start',
            alignContent: 'flex-start',
            gap: `${remCalc(40)} ${remCalc(24)}`,
            w: '100%',
        },
        gridProduct: {
            display: 'grid',
            gridTemplateColumns: {base: 'repeat(2, 1fr)', xl: 'repeat(3, 1fr)'},
            alignItems: 'flex-start',
            alignContent: 'flex-start',
            gap: `${remCalc(40)} ${remCalc(24)}`,
            w: '100%',
        },
        gridProductWidget: {
            display: 'grid',
            gridTemplateColumns: {base: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)'},
            alignItems: 'flex-start',
            alignContent: 'flex-start',
            gap: `${remCalc(40)} ${remCalc(24)}`,
            w: '100%',
        },
        gridProductGuest: {
            gridTemplateColumns: {base: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)'},
        },
        itemContainer: {
            w: {
                lg: 'auto',
                md: 'auto',
                sm: 'auto',
                base: 'auto',
            },
            height: 'auto',
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: {
                lg: remCalc(24),
                md: remCalc(16),
                sm: remCalc(16),
                base: remCalc(16),
            },
        },
        productLabel: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: remCalc(168),
            paddingY: remCalc(6),
            paddingX: remCalc(8),
            gap: remCalc(12),
            bg: 'background.light-blue',
        },
        discount: {
            flex: '1 0 0',
            color: 'text.secondary',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
        },
        flexContainer: {
            w: '100%',
            display: 'flex',
            gap: '0',
            bg: 'background.default',
        },
        productDetails: {
            gap: remCalc(16),
        },
        productImage: {
            width: '100%',
            height: '100%',
        },
        productImageContainer: {
            position: 'relative',
        },
        cartImage: {
            width: '100%',
            height: '100%',
        },
        itemName: {
            flex: '1 0 0',
            color: 'text.default',
            textStyle: 'body-medium',
            fontWeight: 'normal',
        },
        removeIcon: {
            zIndex: 2,
            position: 'absolute',
            variant: 'unstyled',
            top: remCalc(10),
            right: remCalc(10),
            boxSize: {base: 'iconsSize.small', lg: 'iconsSize.medium'},
            minWidth: 'auto',
        },
        badgeGroup: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            maxWidth: '100%',
            flexWrap: 'wrap',
        },
        detailContainer: {
            display: 'flex',
            w: '100%',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: {
                lg: remCalc(16),
                md: remCalc(16),
                sm: remCalc(16),
                base: remCalc(16),
            },
        },
        headerStack: {
            display: 'flex',
            justifyContent: 'space-between',
            alignSelf: 'stretch',
        },
        omniAndPrice: {
            display: 'flex',
            width: remCalc(154),
            justifyContent: 'flex-start',
            alignItems: 'flex-end',
            alignContent: 'flex-end',
            gap: remCalc(8),
            flexWrap: 'wrap',
        },
        vatDetails: {
            display: 'flex',
            width: {
                //TODO : ASK
                lg: remCalc(164),
                md: remCalc(164),
                sm: remCalc(164),
                base: remCalc(164),
            },
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: remCalc(10),
        },
        itemPrice: {
            color: 'text.default',
            textStyle: 'body-medium',
            fontWeight: 'normal',
            textAlign: 'left',
        },
        omnibus: {
            display: 'flex',
            flexDir: {
                lg: 'row',
                md: 'column',
                sm: 'column',
                base: 'column',
            },
            textAlign: 'left',
            width: {
                lg: remCalc(154),
                md: remCalc(95),
                sm: remCalc(95),
                base: remCalc(95),
            },
            height: {
                lg: remCalc(14),
                md: remCalc(32),
                sm: remCalc(32),
                base: remCalc(32),
            },
            flexShrink: 0,
            gap: remCalc(8),
        },
        suggestedPrice: {
            textAlign: 'left',
            textDecorationLine: 'line-through',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        suggestedText: {
            textAlign: 'left',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        vatText: {
            color: 'text.default',
            flex: '1 0 0',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        textQuantity: {
            color: 'text.black',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        quantSelContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(12),
        },
        secondaryButtonGroup: {
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%',
        },
        feedbackContainer: {
            width: '100%',
        },
        wishlistLoginButtonGroup: {
            flexDirection: {base: 'column', md: 'row'},
            gap: {base: remCalc(22), md: remCalc(24)},
            width: {base: '100%', md: 'auto'},
        },
        modalShareHeadingFlex: {
            justifyContent: 'space-between',
            paddingBottom: remCalc(16),
        },
        modalShareHeading: {
            textStyle: 'body-large',
            color: 'text.default',
            fontWeight: 'normal',
        },
        modalShareContent: {
            padding: remCalc(24),
            gap: remCalc(24),
        },
        modalShareHeader: {
            padding: 0,
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.dark',
        },
        modalShareBody: {
            padding: 0,
        },
        modalShareBodyStack: {
            gap: remCalc(24),
        },
        modalShareDescription: {
            textStyle: 'body-medium',
            color: 'text.default',
        },
        modalShareBodyHStack: {
            paddingY: remCalc(8),
            gap: remCalc(8),
        },
        modalShareBodyCopied: {
            height: remCalc(21),
            alignItems: 'center',
            gap: remCalc(8),
            color: 'text.success',
            textStyle: 'body-small',
        },
        modalSharePath: {
            padding: `${remCalc(8)} ${remCalc(16)}`,
            minWidth: remCalc(140),
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            textStyle: 'body-xsmall',
            color: 'text.secondary',
            opacity: '1 !important',
        },
        modalCheckIcon: {
            boxSize: 'iconsSize.small',
        },
        modalOverlay: {background: 'background.overlay-modal'},
        productDetailPrice: {
            textStyle: 'body-large',
            color: 'text.default',
            fontWeight: 'normal',
        },
        productListPrice: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
            fontWeight: 'normal',
        },
        productOmnibusWrapper: {
            h: remCalc(20),
        },
    },
    variants: {
        'account-address': {
            iconContainer: {
                display: 'none',
            },
            container: {
                minHeight: 'fit-content',
                alignItems: 'flex-start',
                gap: {base: remCalc(16), lg: remCalc(24)},
            },
            heading: {
                textStyle: {base: 'head-xsmall', lg: 'head-medium'},
                color: 'text.default',
                fontWeight: 'medium',
                paddingY: remCalc(16),
            },
            addButton: {
                width: {base: '100%', lg: remCalc(334)},
            },
        },
        'account-billing': {
            iconContainer: {
                display: 'none',
            },
            container: {
                minHeight: 'fit-content',
                alignItems: 'flex-start',
                gap: {base: remCalc(16), lg: remCalc(24)},
            },
            heading: {
                textStyle: {base: 'head-xsmall', lg: 'head-medium'},
                color: 'text.default',
                fontWeight: 'medium',
                paddingY: remCalc(16),
            },
            addButton: {
                display: 'none',
            },
        },
        'empty-wishlist': {
            pageActioncontainer: {
                gap: 0,
            },
            textContainer: {
                display: 'flex',
                flexDirection: 'column',
                gap: 0,
            },
        },
    },
}
